export const SLUG_PATTERN = /^[a-z0-9-]{3,}$/;
const URL_PATTERN = /^https?:\/\/.+\..+/;

export const LANDING_PAGE_STEPS = [
  { value: "venue", label: "Venue", title: "Which venue is this page for?", subtitle: "We'll use its logo, events, segments and fans for everything that follows." },
  { value: "template", label: "Blueprint", title: "Pick a starting point", subtitle: "Every blueprint comes with a signup form and a thank-you page. You'll fill in the details next." },
  { value: "content", label: "Content", title: "What's it about?", subtitle: "Link an event and we'll fill in the date and details for you." },
  { value: "signups", label: "Signups", title: "When a fan signs up…", subtitle: "Signups go straight into Fans. Choose where they land and what happens next." },
  { value: "publish", label: "Publish", title: "Ready to go live?", subtitle: "Pick a link, check how it looks when shared, then publish." },
];

export const initialLandingPageStep = (search) => {
  const requested = new URLSearchParams(search).get("step");
  return LANDING_PAGE_STEPS.some((step) => step.value === requested) ? requested : LANDING_PAGE_STEPS[0].value;
};

export const completedLandingPageSteps = (page) => {
  const s = page.settings || {};
  const template = Boolean(page.template_key);
  const content = template && Boolean(s.headline?.trim()) && Boolean(s.cta?.trim());
  const hasSegment = Boolean(s.create_segment) || (s.segment_ids || []).length > 0;
  const afterOk = s.after === "thanks" || URL_PATTERN.test((s.redirect_url || "").trim());

  return {
    venue: Boolean(page.venue_ownership_id),
    template,
    content,
    signups: template && hasSegment && afterOk,
    publish: page.status === "published",
  };
};

export const readyToPublish = (page) => {
  const done = completedLandingPageSteps(page);
  return done.venue && done.template && done.content && done.signups && SLUG_PATTERN.test(page.slug || "");
};

export const furthestReachableStep = (page) => {
  if (!page.venue_ownership_id) return "venue";
  if (!page.template_key) return "template";
  return LANDING_PAGE_STEPS[LANDING_PAGE_STEPS.length - 1].value;
};

const stepIndexOf = (value) => LANDING_PAGE_STEPS.findIndex((step) => step.value === value);

export const stepReachable = (page, value) => stepIndexOf(value) <= stepIndexOf(furthestReachableStep(page));
